import React, { useEffect, useState } from "react";
import ServicesTypeOne from "../../components/services/services-one/ServicesTypeOne";
import Layout from "../../common/Layout";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import { Helmet } from "react-helmet";
import ServiceWe from "../../components/services/services-one/ServiceWe";

const ServicesOne = () => {


    const [services, setServices] = useState(null);
  
    useEffect(() => {
      const fetchSiteSettings = async () => {
        try {
          const response = await fetch(
            "https://rss.fastwebforge.com/api/list/services"
          );
          const data = await response.json();
          setServices(data);
        } catch (error) {
          console.error("Error fetching site settings:", error);
        }
      };
  
      fetchSiteSettings();
    }, []);

  return (
    <>
      <Helmet>
        <title>Service One || RSS Security and Investigations Pty Ltd</title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle="Our Services"
          rootPath="/"
          parentPath="Home"
          currentPath="Service"
        />
        
         <div className="container">
         <div className="row mt-5">
          {services && services.data && Array.isArray(services.data) ? (
            services.data.map((item) => (
              <ServicesTypeOne key={item.id} data={item} />
            ))
          ) : null}
        </div>
         </div>

        <ServiceWe />
        {/* Service End */}
      </Layout>
    </>
  );
};

export default ServicesOne;
